/**
 * Named middleware for the integrated permission-grant screen (Issue #10).
 * Allows access if the user is an administrator on at least one target API.
 */
import { createMultiApiAdministratorGuard } from '#main/app/utils/adminRoleGuard'

export default createMultiApiAdministratorGuard([
  'confManagerApi',
  'channelSessionManagerApi',
  'licenseEcApi',
  'resourceApi',
])
